import { FunctionComponent, useContext, useEffect, useState } from 'react'
import { Box, useMediaQuery } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import gaiaTheme from '../../../root-components/theme'
import FinishedProductService from '../../../shared/services/finished-product/finished-product.service'
import { IFinishedProduct } from '../../../shared/services/finished-product/finished-product.model'
import { FinishedProductForm } from '../../presentation-components/product-components/finished-product-form'
import { BackButtonLink } from '../../presentation-components/display-elements-components/back-button-link'
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications'

export const CreateNewFinishedProductPage: FunctionComponent<{ isEditPage?: boolean }> = ({ isEditPage }) => {

  const { id } = useParams();
  const navigate = useNavigate();
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
  const userNotificationsContext = useContext(UserNotificationsContext)
  const finishedProductService = new FinishedProductService();
  const [finsihedProduct, setFinishedProduct] = useState<IFinishedProduct>();

  useEffect(() => {
    if (isEditPage && id) {
      finishedProductService.getOne(id)
        .then(response => {
          setFinishedProduct(response)
        })
    }
  }, [])

  const onSubmit = (value: IFinishedProduct) => {
    if (isEditPage) {
      finishedProductService.update(id!, value)
        .then(response => {
          navigate(`/products/${response.id}`)
          userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' })
        })
    } else {
      finishedProductService.create(value)
        .then(response => {
          navigate(`/products/${response.id}`)
          userNotificationsContext.openSnackbar({ open: true, message: 'Saved successfully' })
        })
    }
  }

  return (
    <Box sx={{ pb: isMobileMode ? 3 : 6, pl: isMobileMode ? 3 : 6, pr: isMobileMode ? 3 : 6, pt: isMobileMode ? 3 : 5, mt: isMobileMode ? 5 : 0, }}>
      <Box sx={{ mb: 1 }}>
        <BackButtonLink buttonText={!isEditPage ? 'Back to products' : 'Back to product'} link={!isEditPage ? `/products` : `/products/${id}`} />
      </Box>
      {(!isEditPage || finsihedProduct) && <FinishedProductForm
        onSubmit={onSubmit}
        isEditPage={!!isEditPage}
        finishedProduct={finsihedProduct}
      />}
    </Box>
  )
}